<div class="table-column-action__container">
    @if (value !== undefined && value !== null) {
        <span class="table-column-action__display-value" [ngClass]="isValidCallback ? '' : 'table-column-action__display-value--no-callback'" (click)="handleCallback($event)">{{displayValue}}</span>
    } @else {
        <span class="table-column-action__no-data">{{noDataText}}</span>
    }
</div>